var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"50px","background":"#ffffff"}},[_c('span',{staticStyle:{"margin-left":"10px","line-height":"50px"}},[_vm._v(" "+_vm._s(_vm.userForm.UserName)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }